var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganizationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-organization_white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "organization_white",
    clipPath: "url(#clip-organization_white)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17329",
    "data-name": "Path 17329",
    d: "M56.822,821.8h-.881v-.88a1.176,1.176,0,0,0-1.174-1.175H51.243v-1.468h.881A1.176,1.176,0,0,0,53.3,817.1v-2.349a1.176,1.176,0,0,0-1.174-1.174H49.776a1.176,1.176,0,0,0-1.175,1.174V817.1a1.176,1.176,0,0,0,1.175,1.175h.88v1.468H47.133a1.176,1.176,0,0,0-1.175,1.175v.88h-.88a1.176,1.176,0,0,0-1.174,1.174v2.349a1.176,1.176,0,0,0,1.174,1.174h2.348a1.176,1.176,0,0,0,1.174-1.174v-2.349a1.176,1.176,0,0,0-1.174-1.174h-.88v-.88a.588.588,0,0,1,.587-.588h7.633a.588.588,0,0,1,.587.588v.88h-.881a1.176,1.176,0,0,0-1.174,1.174v2.349a1.176,1.176,0,0,0,1.174,1.174h2.349A1.176,1.176,0,0,0,58,825.323v-2.349A1.176,1.176,0,0,0,56.822,821.8Zm-9.4.587a.588.588,0,0,1,.587.587v2.349a.588.588,0,0,1-.587.587H45.078a.588.588,0,0,1-.587-.587v-2.349a.588.588,0,0,1,.587-.587Zm2.349-4.7a.588.588,0,0,1-.587-.588v-2.349a.588.588,0,0,1,.587-.587h2.348a.588.588,0,0,1,.587.587V817.1a.588.588,0,0,1-.587.588Zm7.633,7.633a.588.588,0,0,1-.587.587H54.473a.588.588,0,0,1-.587-.587v-2.349a.588.588,0,0,1,.587-.587h2.349a.588.588,0,0,1,.587.587v2.349Z",
    transform: "translate(-43 -812)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationWhite);
export default __webpack_public_path__ + "static/media/organization_white.02f4bcea76dbc7013ba8b482abdb4442.svg";
export { ForwardRef as ReactComponent };